import { Box, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { BannerCouponName } from "schemas/dashboard";
import { LIGHT_GREY } from "styles/oneOffColor";

import { useCountDown } from "features/Home/Banner/useCountdown";

import MobilePlanCardAutopilot from "../Plan/MobilePlanCard/Autopilot";
import MobilePlanCardPro from "../Plan/MobilePlanCard/Pro";
import MobilePlanCardVirtualAssistant from "../Plan/MobilePlanCard/VirtualAssistant";

interface Props {
  closeDialog: () => void;
}

const OnboardingPaywallMobile = ({ closeDialog }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { bannerPromoCodes } = useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();
  const newSubscriber = bannerPromoCodes.find(
    (p) => p.couponName === BannerCouponName.new_subscriber,
  );

  useEffect(() => {
    if (newSubscriber) {
      createTimer(newSubscriber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSubscriber]);

  return (
    <Box
      sx={{
        backgroundColor: LIGHT_GREY,
        p: 3,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        overflowY: "auto",
      }}
    >
      <Grid container justifyContent="space-between" alignItems={"flex-start"}>
        <Box>
          <Typography sx={{ fontSize: 16, mb: -1 }} color="textSecondary">
            Unlock the tools to
          </Typography>
          <Typography variant="h3">grow faster ⚡</Typography>
        </Box>
        <IconButton
          sx={{
            color: grey[400],
          }}
          onClick={closeDialog}
        >
          <Box component="i" className="fa-thin fa-xmark" />
        </IconButton>
      </Grid>
      {bannerPromoCodes.find(
        (p) => p.couponName === BannerCouponName.new_subscriber,
      )?.discountPercent &&
        display && (
          <Typography sx={{ mt: 2, mb: 2 }}>
            👉{" "}
            <em>
              {" "}
              Your special{" "}
              {
                bannerPromoCodes.find(
                  (p) => p.couponName === BannerCouponName.new_subscriber,
                )?.discountPercent
              }
              % discount ends in <strong>{display}</strong>
            </em>
          </Typography>
        )}
      <MobilePlanCardPro />
      {currentOrg?.showAutopilotPlan ? (
        <MobilePlanCardAutopilot />
      ) : (
        <MobilePlanCardVirtualAssistant />
      )}
    </Box>
  );
};

export default OnboardingPaywallMobile;
